import { BreakpointObserver } from "@angular/cdk/layout";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { EneBreakpoints } from "src/app/core/constants/breakpoints";

@Injectable({ providedIn: "root" })
export class EneLayoutService {
  private _mobileBreakpoint: string = EneBreakpoints.XSmall;

  constructor(private readonly breakpointObserver: BreakpointObserver) {}

  public get isMobileScreen$(): Observable<boolean> {
    return this.breakpointObserver.observe(this._mobileBreakpoint).pipe(map(({ matches }) => matches));
  }

  public get isMobileScreen(): boolean {
    return this.breakpointObserver.isMatched(this._mobileBreakpoint);
  }

  public isBreakpointMatched$(value: string): Observable<boolean> {
    return this.breakpointObserver.observe(value).pipe(map(({ matches }) => matches));
  }

  public isBreakpointMatched(value: string): boolean {
    return this.breakpointObserver.isMatched(value);
  }

  public setMobileBreakpoint(value: string): void {
    this._mobileBreakpoint = value;
  }
}
